import {create} from "zustand";
import {immer} from "zustand/middleware/immer";
import {
  createAuthSlice,
  createConfigSlice,
  createExtractedImagesSlice,
  createI18nSlice,
  createPdfFileUploadSlice,
} from "../store/slices";

const createRootSlice = (set: any, get: any) => ({
  ...createAuthSlice(set, get),
  ...createI18nSlice(set, get),
  ...createConfigSlice(set, get),
  ...createPdfFileUploadSlice(set,get),
  ...createExtractedImagesSlice(set,get)
});

export const useStore = create(immer(createRootSlice));
